import React, { useState, useEffect } from 'react';
import { MapPin, Calendar, Search, Filter } from 'lucide-react';
import { api } from '../services/api';

const LocalEvents = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const data = await api.getListings('event');
                setEvents(data);
            } catch (err) {
                setError('Failed to load events');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchEvents();
    }, []);

    if (loading) return <div className="p-4 text-center">Loading events...</div>;
    if (error) return <div className="p-4 text-center text-red-500">{error}</div>;

    return (
        <div className="pb-20 bg-gray-50 min-h-screen">
            {/* Header */}
            <header className="bg-white p-4 sticky top-0 z-10 shadow-sm">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Local Events</h1>
                        <div className="flex items-center text-gray-500 text-sm mt-1">
                            <MapPin size={14} className="mr-1" />
                            <span>San Francisco, CA</span>
                        </div>
                    </div>
                    <button className="p-2 bg-gray-100 rounded-full">
                        <Filter size={20} className="text-gray-600" />
                    </button>
                </div>

                {/* Search Bar */}
                <div className="relative">
                    <Search size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        placeholder="Search events, concerts, workshops..."
                        className="w-full pl-10 pr-4 py-3 bg-gray-100 rounded-xl outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>
            </header>

            {/* Events List */}
            <div className="p-4 space-y-4">
                {events.map(event => (
                    <div key={event.id} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100">
                        <div className="relative h-48">
                            <img
                                src={JSON.parse(event.image_urls)[0] || 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30'}
                                alt={event.title}
                                className="w-full h-full object-cover"
                            />
                            <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-blue-600">
                                {event.category || 'Event'}
                            </div>
                        </div>
                        <div className="p-4">
                            <div className="flex justify-between items-start mb-2">
                                <h3 className="text-lg font-bold text-gray-900 leading-tight">{event.title}</h3>
                            </div>
                            <p className="text-gray-600 text-sm mb-3 line-clamp-2">{event.description}</p>

                            <div className="flex items-center text-gray-500 text-sm mb-2">
                                <Calendar size={14} className="mr-2" />
                                <span>{new Date(event.event_date).toLocaleDateString()}</span>
                            </div>
                            <div className="flex items-center text-gray-500 text-sm">
                                <MapPin size={14} className="mr-2" />
                                <span>{event.address}</span>
                            </div>
                        </div>
                    </div>
                ))}
                {events.length === 0 && (
                    <div className="text-center text-gray-500 py-10">
                        No events found. Be the first to post one!
                    </div>
                )}
            </div>
        </div>
    );
};

export default LocalEvents;
